import { Fragment } from 'react';
import { Link, useMatches, useSearchParams } from 'react-router';
import type { BreadcrumbHandle } from '../routes/breadcrumbs';

export function AppBreadcrumbs() {
  const matches = useMatches();
  const [searchParams] = useSearchParams();

  const breadcrumbs = matches.flatMap((match) => {
    const handle = match.handle as BreadcrumbHandle | undefined;
    const breadcrumb = handle?.breadcrumb?.({ match, searchParams });
    return breadcrumb ? [breadcrumb] : [];
  });

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="border-b border-border bg-page-bg">
      <ol className="mx-auto flex max-w-[1440px] flex-wrap items-center gap-2 px-6 py-3 text-sm">
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <Fragment key={`${breadcrumb.to ?? 'current'}-${breadcrumb.label}`}>
              {index > 0 && <span className="text-foreground-faded">/</span>}
              {isLast || !breadcrumb.to ? (
                <span aria-current="page" className="font-medium text-foreground">
                  {breadcrumb.label}
                </span>
              ) : (
                <Link to={breadcrumb.to} className="text-primary transition-colors hover:text-primary-hover hover:underline">
                  {breadcrumb.label}
                </Link>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}